import { default as MenuItemMUI } from '@material-ui/core/MenuItem';
/**
 * Import da biblioteca "styled-components", que permite escrever 
 * CSS simples para os componentes sem acontecer conflitos com os 
 * nomes das clases, são escritos entre Tagged Templates Literals(``).
 */
import styled from 'styled-components';

/**
 * Estilização do MenuItemMUI
 */
export default styled(MenuItemMUI)`
  &.MuiMenuItem-root {
    width: calc(100% - 27px);

    &:hover {
      background: rgba(96, 52, 190, 0.08);
    }

    > div {
      &:hover {
        text-decoration: none;
      }

      > div {
        display: flex;
        flex-direction: row;
        align-items: center;

        > img {
          flex: 0 0 auto;
          width: 36px;
          height: 36px;
          margin-right: 8px;
          border-radius: 3px;
        }

        h4 {
          color: rgba(0, 0, 0, 0.6);
          width: 140px;
          margin-right: 27px;
          font-size: 12px;
          line-height: 14px;
          text-transform: uppercase;
          margin-bottom: 1px;
          transform: translateY(-2px);
        }

        .desc-bt {
          padding: 0;
          border: none;
          background: transparent;
          margin-right: 12px;
          color: #3c71dd;
          transition: opacity 300ms;
        }
      }

      .description {
        max-height: 0;
        padding: 0;
        opacity: 0;
        transition: max-height 300ms, opacity 100ms;
        overflow: hidden;

        &.expanded {
          padding: 12px 13px 8px 15px;
          max-height: 100px;
          opacity: 1;
          transition: max-height 300ms, opacity 600ms;
        }

        & p {
          margin: 0;
          word-break: break-word;
          white-space: normal;
          font-size: 11px;
          line-height: 12px;
          font-family: Roboto;
          font-style: normal;
          font-weight: normal;
          color: #5e5e5e;
        }
      }
    }
  }
`;
